module.exports = __webpack_public_path__ + "img/20190725161359502.37b3d79b.png";